import {
  Component,
  OnInit,
  ChangeDetectorRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { RenderedService } from '../../rendered.service';
import { CourseService } from '@scaffold/services/course.service';
import { HTMLModalComponent } from '@scaffold/dialogs/htmlmodal/htmlmodal.component';
import { ExportModalComponent } from '@scaffold/dialogs/export-modal/export-modal.component';
import { ScaffoldDialogService } from '@app/framework/dialog/scaffold-dialog.service';
import { ViewModalComponent } from '@scaffold/dialogs/view-modal/view-modal.component';
import { ItemsService } from '@scaffold/services/items.service';
import { AddDataComponent } from '@scaffold/dialogs/add-data/add-data.component';
import { ViewUpdateService } from '@scaffold/services/view-update.service';
import { ConfirmDialog } from '@generic/confirm-dialog/confirm-dialog.component';
import { TranslationService } from '@services/translation.service';

@Component({
    selector: 'scaffold-button',
    templateUrl: './scaffold-button.component.html',
    styleUrls: ['./scaffold-button.component.scss'],
    standalone: false
})
export class ScaffoldButtonComponent
  extends BaseScaffoldComponent
  implements OnInit
{
  constructor(
    private translationService: TranslationService,
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    private courseService: CourseService,
    private dialog: ScaffoldDialogService,
    private itemsService: ItemsService,
    private viewUpdate: ViewUpdateService
  ) {
    super(cdr, renderedService);
  }
  /**Reference holder for preview dialog*/
  dialogRef;
  /** flag to prevent multiple create operations*/
  created;
  @Output() moveHandler = new EventEmitter<any>();
  ngOnInit(): void {}
  /**
   * Executes the designated function
   * @param e function to execute
   */
  execute(e: Event, o) {
    console.log(o);
    e.stopPropagation();
    this[o]();
    return false;
  }

  /**
   * Check if the input should be disabled
   */
  checkDisable() {
    return this.renderedService.isDisabled(this.info.type);
  }
  /**
   * Opens an html preview for the current view
   * @param e
   */
  preview(e) {
    let title;
    if (this.item?.text_value?.length) {
      title = this.item.text_value.join(', ');
    } else {
      title =
        this.info.title +
        '_' +
        (this.info.view_details.title || this.info.view_details.mode);
    }
    let settings: any = {
      context: {
        data: {
          title,
          url: `${this.info.type}/${this.info.id}?mode=${this.info.view_details.mode}&format=html`,
        },
      },
    };
    this.dialogRef = this.dialog.open(HTMLModalComponent, settings);
  }
  /**
   * Opend gradebook view for current course
   * @param e
   */
  export(e) {
    const title =
      this.info.title +
      ' ' +
      this.translationService.getTranslatedContent(
        'gradebook_data',
        'Gradebook Data'
      );
    let settings: any = {
      context: {
        data: {
          title,
        },
      },
    };
    this.dialog.open(ExportModalComponent, settings);
  }
  /**Opens the create view of the curent data */
  openSettings() {
    console.log(this.info);
    this.openView('create');
  }
  /**Opens the read view of the current data */
  openRead() {
    console.log(this.info);
    this.openView('read');
  }
  /**Opens the move dialog for a list */
  openMove() {
    console.log(this.info);
    this.moveHandler.emit('move');
    this.renderedService.triggerUpdate('move');
  }

  /**
   * Opens a view of the current data
   * @param mode view mode to open
   */
  openView(mode: any) {
    console.log(this);
    this.openViewHandler(mode, this.info);
  }
  /**
   * Opens a view of specified data
   * @param mode view mode to open
   * @pa
   */
  openViewHandler(mode: any, item: any) {
    let settings: any = {
      context: {
        data: {
          mode: mode,
          item: item || this.info.children || this.info,
          //   parent: parent || this.info
        },
      },
    };
    this.dialogRef = this.dialog.open(ViewModalComponent, settings);
    this.dialogRef.onClose.subscribe(result => {
      console.log(result);
      console.log(this.item);
      console.log(this.info);
      if (result && (result !== 'string' || result.length > 0)) {
        if (this.item && this.item.list_view) {
        } else if (this.info.children) {
          this.courseService
            .get(
              this.info.type +
                '/' +
                this.info.id +
                '/' +
                result.type +
                '/' +
                result.id +
                '?mode=' +
                (this.item.list_mode || 'list')
            )
            .subscribe(updated => (this.info.children = updated));
        }
      }
    });
  }
  /**create a copy of the current item */
  duplicateItem() {
    console.log(this.info);
    let item = this.info;
    this.createData(item.type, item.parent, true, item);
  }
  /**
   * create a data item
   * @param type type to create
   * @param parent parent data item
   * @param add adding is allowed in thew current item
   * @param duplicate item to duplicate
   */
  createData(type, parent, add, duplicate) {
    console.log(this.item);
    if (this.item.use_defaults) {
      if (!this.created) {
        this.created = true;
        let default_data = {
          type: type,
          data: {},
        };
        this.item.new_defaults.forEach(def => {
          default_data.data[def.key] = def.value;
        });

        let path = '';
        if (this.info.type && this.info.id)
          path += this.info.type + '/' + this.info.id + '/';
        path += type;
        this.itemsService.createData(path, default_data).subscribe(d => {
          this.created = false;
          if (this.info) {
            this.viewUpdate.triggerListChange({
              list_type: 'list',
              type: d.type,
              added: d.id,
              parent_type: this.info.type,
              parent_id: this.info.id,
            });
          }
        });
      }
    } else {
      console.log(parent);
      let data = {};
      if (this.item.param && this.item.req_value) {
        data[this.item.param] = this.item.req_value;
      }
      let settings: any = {
        context: {
          data: {
            comp: this,
            parent: parent,
            type: type,
            allowAdd: add,
            duplicate: duplicate,
            data: data,
          },
        },
      };
      this.dialogRef = this.dialog.open(AddDataComponent, settings);
      this.dialogRef.onClose.subscribe(result => {
        //console.log(result)
        /* if (result && (result !== 'string' || result.length > 0)) {
          if (this.item.param) {
            this.info[this.item.param] = result.id;
            this.item.value = result.id;
            this.sendUpdate(this.item.param, result.id, this.info)
          }
          if (parent) {
            this.itemsService.updateData(parent.type, parent.id, type);
          } else {
            this.itemsService.updateData("courses", this.courseService.id, type);
          }
          if (this.item && this.item.list_view && this.item.type) {
          } else if (this.info.children) {
            this.courseService.get("courses/" + this.courseService.id + "/" + result.type + '/' + result.id + "?mode=" + (this.item.list_mode || "list")).subscribe(updated => this.info.children = updated);

          }
        }*/
      });
    }
  }
  /**Open confirm dialog for a delete operation*/
  deleteData() {
    let settings: any = {
      context: {
        data: {
          title:
            this.translationService.getTranslatedContent(
              'delete_item',
              'Delete Item'
            ) + '?',
          message:
            this.translationService.getTranslatedContent(
              'are_you_sure_you_want_to_delete_this_item',
              'Are you sure you want to delete this item'
            ) + '?',
        },
      },
    };
    let dialogRef = this.dialog.open(ConfirmDialog, settings);

    dialogRef.onClose.subscribe(result => {
      if (result) {
        //this.deleteDataEvent.emit(this.info);
        this.deleteHandler(this.info);
      }
    });
  }
  /**
   * Delete a data item
   * @param item item to delete
   */
  deleteHandler(item) {
    let path = '/' + item.type + '/' + item.id;
    if (item.hasOwnProperty('link_id')) {
      this.unlink(item);
    } else {
      this.itemsService.deleteData(path).subscribe(d => {
        this.viewUpdate.triggerListChange({
          list_type: 'list',
          type: item.type,
          removed: item.id,
        });
      });
    }
  }
  /**
   * remove a link to an item
   * @param item item to unlink
   */
  unlink(item) {
    if (item.link_id) {
      let path = '/data_link_item/' + item.link_id;
      this.itemsService.deleteData(path).subscribe(d => {
        if (d.deleted) {
          //let index = item.linked.indexOf(item);
          //this.item.linked.splice(index, 1);
          this.viewUpdate.triggerListChange({
            list_type: 'link',
            parent_id: item.link_parent,
            type: item.type,
            removed: item.id,
          });
          this.viewUpdate.triggerListChange({
            list_type: 'link',
            parent_id: item.id,
            type: item.link_parent_type,
            removed: item.link_parent,
          });
        }
      });
    } else {
      console.warn('No link id provided');
    }
    console.log(item);
  }
}
